export default {"src":"/_next/static/media/theater.d0be3189.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};